import type { FC } from 'react';

import AddressFinder from '@eneco/components/AddressFinder/AddressFinder';
import RichText from '@eneco/components/RichText/RichText';
import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import { Box, Button, Form } from '@eneco/sparky';
import { WarmthCheckAddressFinderRendering } from '@sitecore/types/WarmthCheckAddressFinder';
import { FormProvider } from 'react-hook-form';

import useWarmChecker from './hooks/useWarmChecker';

const WarmChecker: FC<WarmthCheckAddressFinderRendering> = ({ fields: textualData }) => {
  const { formMethods, error, handleFormSubmit, isHouseNumberSuffixRequired, setIsHouseNumberSuffixRequired } =
    useWarmChecker(textualData);

  const { handleSubmit } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box>
          <AddressFinder
            customLabels={{
              houseNumber: textualData?.address?.houseNumberFormField,
              postalCode: textualData?.address?.postalCodeFormField,
              houseNumberSuffix: textualData?.address?.houseNumberSuffixFormField,
            }}
            isSuffixRequired={isHouseNumberSuffixRequired}
            setIsSuffixRequired={setIsHouseNumberSuffixRequired}
          />
        </Box>

        {error && (
          <Box paddingTop="2">
            <TrackedNotificationBox
              emphasis="low"
              isAlert
              text={<RichText html={error.content || ''} />}
              title={error.title || ''}
              variant="error"
            />
          </Box>
        )}

        <Box paddingTop="6">
          <Button size="regular" type="submit">
            {textualData?.content?.buttonText?.value}
          </Button>
        </Box>
      </Form>
    </FormProvider>
  );
};

export { WarmChecker };
export default WarmChecker;
